var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-text-section",
    { attrs: { title: _vm.$t("payment-method.credit-card") } },
    [
      _vm.data.installments
        ? _c("emd-text-content", {
            attrs: {
              title: _vm.$t("installments"),
              content: _vm.$t("installments-description", [
                _vm.data.installments?.length,
              ]),
            },
          })
        : _vm._e(),
      _c(
        "emd-text-content",
        { attrs: { title: _vm.$t("fees"), content: _vm.$t("noFees") } },
        [
          _vm.data.hasFees
            ? [
                _c(
                  "a",
                  {
                    staticClass: "emd-link url-color",
                    on: { click: _vm.showInstallmentsModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("seeFees")) + " ")]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("emd-text-content", {
        attrs: {
          title: _vm.$t("operationType"),
          content: _vm.data.operationType,
        },
      }),
      _c("emd-text-content", {
        attrs: {
          title: _vm.$t("description"),
          content: _vm.data.statementDescriptor,
        },
      }),
      _vm.installmentsModalIsVisible
        ? _c("installments-modal", {
            attrs: { installments: _vm.data.installments },
            on: { closeClick: _vm.closeInstallmentsModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }